module.exports = __webpack_public_path__ + "media/Loops Vocals.7120d333.wav";